import React, { useEffect } from "react";
import "../Style/PrivacyPolicy.css";
import "../Style/Term&Condition.css";
import { MdOutlineAttachFile } from "react-icons/md";

const TermAndCondition = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="term-main-container">
      <div className="aboutus-border"></div>
      <div className="first-section">
        <div>
          <h1 className="f-h1" style={{ color: "var(--primary-color)" }}>
            Terms of <span>Service</span>
          </h1>
          <p style={{ fontSize: "12px", textAlign: "center" }}>
            Last Updated 11/03/2025
          </p>
        </div>
        <div>
          <p>
            These Terms of Service ("Terms") govern your use of the website and
            services provided by Homoeopathic Health Care & Research Center. By
            accessing or using our website and services, you agree to comply
            with these Terms. If you do not agree, please discontinue use of our
            services.
          </p>
        </div>
      </div>

      <div className="term-content">
        <div>
          <h1>1. Acceptance of Terms</h1>
          <ul>
            <li>
              {" "}
              By accessing and using the Homoeopathic Health Care & Research
              Center website, you agree to comply with these Terms and
              Conditions.
            </li>
            <li>
              If you do not agree with any part of these terms, please do not
              use the website.
            </li>
          </ul>
        </div>
        <div>
          <h1>2. Medical Disclaimer</h1>
          <ul style={{ marginLeft: "60px" }}>
            <li>
              The content on this website is for informational purposes only and
              does not constitute medical advice.
            </li>
            <li>
              Always consult a qualified healthcare professional before making
              any health-related decisions.
            </li>
          </ul>
        </div>

        <div>
          <h1>3. Disease Information</h1>
          <ul>
            <li>
              Users can access information about various diseases and
              homoeopathic treatments provided by the center.
            </li>
            <li>
              The content is based on homoeopathic principles and may not be
              universally accepted by all medical practitioners.
            </li>
          </ul>
        </div>

        <div>
          <h1>4. Appointment Booking</h1>
          <ul>
            <li>Users can book appointments online through the website.</li>
            <li>
              Appointment confirmation is subject to availability and will be
              communicated via email or SMS.
            </li>
            <li>
              The center reserves the right to reschedule or cancel appointments
              due to unforeseen circumstances.
            </li>
          </ul>
        </div>

        <div>
          <h1>5. User Responsibilities</h1>
          <ul>
            <li>
              Users must provide accurate personal and medical details while
              booking an appointment.
            </li>
            <li>
              Misuse of the appointment system may result in restrictions on
              future bookings.
            </li>
          </ul>
        </div>

        <div>
          <h1>6. Privacy and Data Protection</h1>
          <ul>
            <li>
              All user information, including medical history and contact
              details, will be kept confidential.
            </li>
            <li>
              The center will not share personal data with third parties except
              as required by law.
            </li>
          </ul>
        </div>

        <div>
          <h1>7. Refund Policy</h1>
          <ul>
            <li>
            If the center offers paid consultation services, payments are non-refundable once the appointment is successfully completed. 
            </li>
          </ul>
        </div>

        <div>
          <h1>8. Website Usage</h1>
          <ul>
            <li>
              Unauthorized use of this website, including data scraping or
              hacking, is strictly prohibited.
            </li>
            <li>
              The center reserves the right to modify or remove content at any
              time without prior notice.
            </li>
          </ul>
        </div>

        <div>
          <h1>9. Limitation of Liability</h1>
          <ul>
            <li>
              The center is not responsible for any direct or indirect loss due
              to reliance on the website’s content.
            </li>
            <li>
              We do not guarantee specific results from our treatments, as
              outcomes vary from patient to patient.
            </li>
          </ul>
        </div>
        <div>
          <h1>10. Amendments</h1>
          <ul>
            <li>
              The center reserves the right to modify these Terms and Conditions
              at any time.
            </li>
            <li>
              Continued use of the website after updates implies acceptance of
              the revised terms.
            </li>
          </ul>
        </div>
        <p>
          For any queries regarding these terms, please contact us at{" "}
          <b style={{ color: "var(--primary-color)", fontSize: "18px" }}>
            rk@drrkvishwakarma.com
          </b>
          .
        </p>
      </div>
    </div>
  );
};

export default TermAndCondition;
